export const checkoutB2B = {
  checkoutB2B: {
    noPoNumber: 'None',
    poNumber: {
      label: 'PO#',
      placeholder: '...',
    },
    endCustomerPO: {
      label: 'End Customer PO#',
      placeholder: '...',
    },
    costCenter: 'Cost Center',
    placeholder: 'Enter P.O',
    availableLabel: 'The available delivery addresses for you depend on the cost center unit',
    invalid: {
      accountType: 'Your account does not allow you to complete the purchase here.',
    },
    methodOfPayment: {
      paymentType: 'Payment Information',
    },
    review: {
      poNumber: 'Purchase Order Number',
    },
    progress: {
      methodOfPayment: 'Payment Information',
    },
    invalidCostCenter: 'Invalid cost center.',
  },
};
